import type { ReflexPanelProposal } from "../../services/reflexPanels.service";
import type { ReportPreviewEvidence } from "../../services/signOff.service";

export interface ReflexSignOutContinuation {
  reviewedProposalKeys: string[];
  previewEvidence?: ReportPreviewEvidence;
}

export function buildReflexSignOutContinuation(
  proposals: ReflexPanelProposal[],
  acceptedProposalKeys: string[],
  previewEvidence?: ReportPreviewEvidence
): ReflexSignOutContinuation {
  const reviewedProposalKeys = proposals.map(
    (proposal) => proposal.proposalKey
  );
  if (acceptedProposalKeys.length > 0) return { reviewedProposalKeys };
  return { reviewedProposalKeys, previewEvidence };
}
